import { useState } from 'react';
import type { Sent } from '@accounts/domain';
import { usePresence } from '@accounts/session';
import { Button, Dialog } from '@beyond-js/ui/react';

/**
 * What became of the invitations just sent (ARR-03, ARR-23): which were mailed, and the one-time link of
 * each, to copy when the message was not sent or to send another way. A link is shown once and never
 * stored; it wraps inside the dialog, so every button stays in reach.
 */
export function Secret({ sent, onClose }: { sent?: Sent[]; onClose: () => void }) {
	const { text, language } = usePresence();
	const [copied, setCopied] = useState<string>();

	const link = (secret: string) => `${globalThis.location.origin}/invitations/${secret}`;
	function close() {
		setCopied(undefined);
		onClose();
	}

	return (
		<Dialog open={Boolean(sent?.length)} labels={Dialog.labels[language]} title={text('invitations.results')} onClose={close}>
			<div className="flex flex-col gap-4">
				<ul className="flex flex-col gap-4">
					{(sent ?? []).map(entry => (
						<li key={entry.email} className="flex flex-col gap-2">
							<p className="break-all text-body text-ink">
								{entry.error
									? text('invitations.delivery.error', { email: entry.email, reason: entry.error.code === 'ALREADY_MEMBER' ? text('invitations.alreadyMember') : entry.error.message })
									: text(`invitations.delivery.${entry.delivery === 'sent' ? 'sent' : entry.delivery === 'failed' ? 'failed' : 'off'}`, { email: entry.email })}
							</p>
							{entry.replaced ? <p className="text-small text-ink-muted">{text('invitations.replaced')}</p> : null}
							{entry.secret ? (
								<div className="flex flex-col gap-2 sm:flex-row sm:items-start">
									<code className="code-box block min-w-0 flex-1 break-all rounded-beyond border border-line bg-sunken text-small text-ink">{link(entry.secret)}</code>
									<Button
										variant="secondary"
										small
										onClick={() => {
											void globalThis.navigator?.clipboard
												?.writeText(link(entry.secret as string))
												.then(() => setCopied(entry.email))
												.catch(() => setCopied(undefined));
										}}
									>
										{copied === entry.email ? text('action.copied') : text('action.copy')}
									</Button>
								</div>
							) : null}
						</li>
					))}
				</ul>
				<div className="flex justify-end">
					<Button variant="primary" onClick={close}>
						{text('action.close')}
					</Button>
				</div>
			</div>
		</Dialog>
	);
}
